import { Button, SidebarTrigger, useIsMobile } from "@elit-hair/elit-ui";
import { Sling as Hamburger } from "hamburger-react";
import { PanelRight } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { MobileMenu } from "@/components/mobile-menu/mobile-menu";

import { usePageTitle } from "./use-page-title";

type HeaderProps = {
    onToggleRightSidebar: () => void;
    showRightSidebarToggle?: boolean;
};

export function Header({ onToggleRightSidebar, showRightSidebarToggle = false }: HeaderProps) {
    const { t } = useTranslation();
    const pageTitle = usePageTitle();
    const isMobile = useIsMobile();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <header className="sticky top-0 z-20 w-full bg-background border-b rounded-t-lg border-border/50">
            <div className="flex flex-col">
                <div className="flex justify-between items-center w-full h-14 px-3">
                    {/* Left: Title */}
                    <div className="flex items-center gap-2 min-w-0 flex-1">
                        <SidebarTrigger />
                        <h2 className="font-semibold text-xl truncate">{t(pageTitle)}</h2>
                    </div>

                    {/* Right: Controls */}
                    <div className="flex items-center gap-2 shrink-0">
                        {/* Right Sidebar Toggle */}
                        {!isMobile && showRightSidebarToggle && (
                            <Button
                                variant="ghost"
                                size="icon"
                                onClick={onToggleRightSidebar}
                                className="h-8 w-8 shrink-0"
                            >
                                <PanelRight />
                            </Button>
                        )}

                        {/* Hamburger for mobile */}
                        {isMobile && (
                            <div className="ml-1">
                                <Hamburger toggled={mobileMenuOpen} toggle={setMobileMenuOpen} size={20} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Mobile Menu overlay */}
            {isMobile && <MobileMenu open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />}
        </header>
    );
}
